import React from "react";

const stats = [
  { value: "500+", label: "Titles Published" },
  { value: "18", label: "Genres Covered" },
  { value: "100%", label: "Rights & Royalties Kept" },
  { value: "24/7", label: "Author Support" },
];

export default function ProofRibbon() {
  return (
    <section className="relative z-30 -mt-10 px-4">
      <div className="mx-auto max-w-[1200px] rounded-3xl border border-ink/10 bg-white/95 p-6 shadow-editorial backdrop-blur md:p-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:justify-between">
          {/* Satisfaction badge */}
          <div className="flex items-center gap-4">
            <img loading="lazy" decoding="async" src="/images/Badge.webp" alt="100% Satisfaction Guaranteed" className="h-16 w-16 animate-float-slow object-contain" />
            <div className="text-left">
              <p className="font-display text-lg font-semibold text-ink">Satisfaction Guaranteed</p>
              <p className="text-xs text-ink-soft">Award-winning, author-first publishing</p>
            </div>
          </div>

          <span className="hidden h-14 w-px bg-ink/10 md:block" />

          {/* Stats */}
          <div className="grid w-full grid-cols-2 gap-x-6 gap-y-5 sm:w-auto sm:grid-cols-4 sm:gap-x-10">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <p className="font-display text-2xl font-semibold text-brand-700">{s.value}</p>
                <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-ink-soft">{s.label}</p>
              </div>
            ))}
          </div>

          <span className="hidden h-14 w-px bg-ink/10 lg:block" />

          {/* Trustpilot */}
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center gap-1 text-gold lg:justify-start">
              {"★★★★★".split("").map((s, i) => (
                <span key={i} className="text-lg">{s}</span>
              ))}
            </div>
            <p className="mt-1 text-xs text-ink-soft">Rated <span className="font-semibold text-ink">Excellent</span> by our authors</p>
          </div>
        </div>
      </div>
    </section>
  );
}
